import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_BUYER_ARRANGED_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemBuyerArrangedFeeMaybe = props => {
  const { lineItems, intl } = props;

  const shippingFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_BUYER_ARRANGED_FEE && !item.reversal
  );

  return shippingFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.buyerArrangedFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, shippingFeeLineItem.unitPrice)}</span>
    </div>
  ) : null;
};

LineItemBuyerArrangedFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemBuyerArrangedFeeMaybe;
